// theme-editor.js — FINAL WORKING VERSION

// SLIDESHOW BLOCK SELECT
document.addEventListener('shopify:block:select', function(event) {
  if (!event.target.classList.contains('slideshow__slide')) return;
  const slideshow = event.target.closest('slideshow-component');
  if (!slideshow) return;
  slideshow.pause();
  setTimeout(() => {
    if (slideshow.slider) slideshow.slider.scrollTo({ left: event.target.offsetLeft });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function(event) {
  if (!event.target.classList.contains('slideshow__slide')) return;
  const slideshow = event.target.closest('slideshow-component');
  if (slideshow && slideshow.autoplayButtonIsSetToPlay) slideshow.play();
});
// theme-editor.js — FINAL: ALWAYS ADD NEW ENTRY

document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/account')) return;

  const forms = document.querySelectorAll('form[action*="/account/addresses"]');
  if (forms.length === 0) return;

  // === CONFIG ===
  const SHOPIFY_TOKEN = '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'; // YOUR TOKEN
  const FILE_URL = 'https://cdn.shopify.com/s/files/1/0943/5791/3943/files/customers.json';
  const SHOP_DOMAIN = 'aaasdm-bb.myshopify.com';
  // ===============

  const customerEl = document.querySelector('[data-customer-id]');
  if (!customerEl) return;

  const customerId = parseInt(customerEl.dataset.customerId, 10);
  const customerName = customerEl.dataset.customerName || 'Unknown';
  const customerEmail = customerEl.dataset.customerEmail || 'unknown@shop.com';

  if (!customerId) return;

  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      const plateInput = form.querySelector('input[name="address[company]"]');
      const updateInput = form.querySelector('input[name="update_json"]');
      if (!plateInput || !updateInput) return;

      const plate = plateInput.value.trim();
      if (!plate) return;

      try {
        const res = await fetch(FILE_URL);
        if (!res.ok) throw new Error('File not public');
        let data = await res.json();

        // CHECK IF USER ALREADY EXISTS
        const exists = data.some(u => Number(u.customerid) === customerId);

        if (!exists) {
          // ADD NEW USER
          data.push({
            customerid: customerId,
            name: customerName,
            email: customerEmail,
            company: plate,
            bookings: []
          });

          // UPLOAD NEW JSON
          const jsonStr = JSON.stringify(data, null, 2);
          const base64 = btoa(unescape(encodeURIComponent(jsonStr)));

          await fetch(`https://${SHOP_DOMAIN}/admin/api/2024-10/files.json`, {
            method: 'POST',
            headers: {
              'X-Shopify-Access-Token': SHOPIFY_TOKEN,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              file: { filename: 'customers.json', attachment: base64 }
            })
          });

          console.log('NEW USER ADDED:', { customerId, plate });
        } else {
          console.log('User already exists — not adding duplicate');
        }

      } catch (err) {
        console.error('Sync failed:', err);
      }
    });
  });
});